export const fields = [
  {
    //渲染字段
    dataIndex: "content",
    key: "content",
    title: "内容",
    width: 250,
    isShow: true,
    scopedSlots: {
      customRender: "content",
    },
  },
  {
    dataIndex: "author",
    key: "author",
    title: "作者",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "time",
    key: "time",
    title: "时间",
    width: 200,
    isShow: true,
    scopedSlots: {
      customRender: "time",
    },
  },
  {
    dataIndex: "statusStr",
    key: "statusStr",
    title: "状态",
    width: 180,
    isShow: true,
    scopedSlots: {
      customRender: "color",
    },
  },
  {
    dataIndex: "moduleStr",
    key: "moduleStr",
    isShow: true,
    title: "所属模块",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 200,
    isShow: true,
    scopedSlots: {
      customRender: 'action'
    }
  }
]
export const slotOpt = [{
    slot: 'action',
    component: 'Action',
    list: []
  },
  {
    slot: "content",
    component: "Content",
  },
  {
    slot: 'time',
    component: 'Time'
  }
]

export const formInfo = [
  { label: '内容标题', value: '-', key: 'title' },
  { label: '模块', value: '-', key: 'moduleIdStr' },
  { label: '作者', value: '-', key: 'author' },
  { label: '封面', value: '-', key: 'picture', isVHtml: true },
  { label: '发布时间', value: '-', key: 'publishTime' },
  { label: '内容简介', value: '-', key: 'summary' },
  { label: '内容', value: '-', key: 'content', isVHtml: true },
  { label: '链接', value: '-', key: 'link' },
  { label: '附件', value: '-', key: 'appendixFiles', isFile: true }
]
